// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Store from "../../store/Store.bs.js";
import * as React from "react";
import * as Loading from "../Loading/Loading.bs.js";
import * as PostCard from "../PostCard/PostCard.bs.js";

function PostList(Props) {
  var className = Props.className;
  var posts = Store.useAppSelector(function (state) {
        return state.posts;
      });
  var loading = Store.useAppSelector(function (state) {
        return state.loading;
      });
  return React.createElement("section", {
              className: className
            }, loading ? React.createElement(Loading.make, {}) : posts.map(function (post) {
                    return React.createElement(PostCard.make, {
                                postData: post,
                                key: String(post.id)
                              });
                  }));
}

var make = PostList;

export {
  make ,
  
}
/* Store Not a pure module */
